import React from 'react';
import LinearProgress from '@mui/material/LinearProgress/LinearProgress';
import useGlynt from './useGlynt';
import { IDocument } from '../../types/my-types';
import { useQuery, useMutation } from '@tanstack/react-query';

export default function useDocGen(docId: string) {
  const glynt = useGlynt();
  const [interval, setInterval] = React.useState<number | false | undefined>(1000);

  const { isPending, isError, data } = useQuery({
    queryKey: ['document', docId],
    queryFn: async () => await (await glynt).document.retrieveAdvance(docId),
    refetchInterval: interval,
    enabled: !(docId?.length === 0),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5
  });
  //note: use called of mutation will only generate page image once, but it won't generate for new page
  const { mutate: generatePage } = useMutation({
    mutationFn: async (id: string) => {
      const response = await (await glynt).document.createPages(id);
      return response;
    }
  });
  const [calledGeneratePage, setCalledGeneratePage] = React.useState(false);
  React.useEffect(() => {
    setInterval(700);
    setCalledGeneratePage(false);
  }, [docId]);

  if (isPending) {
    return <LinearProgress />;
  }

  if (isError) {
    return <div>Sorry, failed to load document.</div>;
  }

  const doc: IDocument = data as IDocument;

  if (doc.pages.length > 0 && interval) {
    setInterval(false);
  }

  if (doc.pages.length === 0 && !calledGeneratePage) {
    setCalledGeneratePage(true);
    generatePage(doc.id);
  }

  return doc;
}
